import { globalLogger } from './global-logger';

import { translate } from './translate';
import { pageNotification } from './notify';
import { testIsNonEmptyString } from '../../lib/test-and-assert/test-base';

function sendNotification(message) {
    if (!isNewNotificationSupported()) {
        return;
    }

    if (Notification.permission !== 'granted') {
        return;
    }

    if (!testIsNonEmptyString(message)) {
        return;
    }

    showNotification(message);
}

function showNotification(message) {
    try {
        let options = {
            body: translate(message),
        };

        let n = new Notification(document.domain, options);

        n.onclick = function (event) {
            window.focus();
        };

        globalLogger.log('push notification send done');
    } catch (e) {
        globalLogger.log('push notification send fail', {
            exception_message: e.message,
        });
    }
}

function isAvailable() {
    return 'Notification' in window && isNewNotificationSupported();
}

function requestPermission() {
    let deferred = $.Deferred();

    Notification.requestPermission().then(function (result) {
        if (result === 'denied') {
            globalLogger.log('push notification get permission denied');

            pageNotification.warning('Notifications are blocked. Please allow notifications in your browser settings.');

            deferred.reject();

            return;
        } else if (result === 'granted') {
            globalLogger.log('push notification get permission done');

            deferred.resolve();

            return;
        }

        deferred.reject();
        globalLogger.log('push notification get permission fail');
    });

    return deferred;
}

function isNewNotificationSupported() {
    if (!window.Notification || !Notification.requestPermission) {
        return false;
    }

    if (Notification.permission === 'granted') {
        return true;
    }

    try {
        new Notification('');
    } catch (e) {
        if (e.name === 'TypeError') {
            return false;
        }
    }

    return true;
}

export { sendNotification };
export { isAvailable };
export { requestPermission };
